import {BaseModel} from '../../../shared';

export class Adjunto extends BaseModel{
  adjuntoId: string;
  adjuntoNombre: string;
  adjuntoFechaCreacion: string;
  adjuntoContenido: string;
  adjuntoExtension: string;
  adjuntoComentario: string;
  adjuntoGeoreferencia?: string;
  adjuntoURL?: string;
  chacraId?: string;
  adjuntoTipo?: string = null;
}
